<template>
    <kgr-loading
        v-if="loading"
        :inline="true"
    />
    <select
        v-else
        :id="id"
        v-model="selected"
        class="kgr-select"
        @change="update()"
    >
        <option
            :value="null"
            class="kgr-select__option"
        >
            {{ $t('pleaseChooseAnOption') }}
        </option>

        <option
            v-for="option in options"
            :key="option.id"
            :value="option"
            class="kgr-select__option"
        >
            {{ option.value }}
        </option>
    </select>
</template>

<script>
import ClubRepository from '../../../js/repository/ClubRepository';
import Loading from '../../common/Loading.vue';
import ParameterValue from '../../../js/dto/ParameterValue';

export default {
    components: {
        'kgr-loading': Loading,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: ParameterValue,
            required: false,
        },
    },
    data() {
        return {
            options: [],
            loading: true,
            selected: null,
        }
    },
    computed: {
        id() {
            return `kgr-member-honor-select-club-${this.clubId}`
        },
    },
    watch: {
        value(newVal) {
            if (!newVal) {
                this.selected = null;
            }
        }
    },
    created() {
        if (this.value) {
            this.selected = this.value;
        }

        ClubRepository.findMemberHonors(this.clubId)
            .then(
                memberHonors => {
                    this.options = memberHonors;
                    this.loading = false;
                })
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        update() {
            const value = this.selected;
            const selection = '' === value ? null : value
            this.$emit('input', selection);
            this.$nextTick(() => {
                this.$emit('post-input', selection);
            });
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
